// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"d1eb53e6","145":"961654c1","149":"050323bf","402":"690924dc","443":"619027f4","464":"e94fb946","717":"c94fb627","778":"bf8a89c3","859":"c7ca4087","953":"fe0f5fdd","972":"040c215a"}[chunkId] + ".chunk.js";
};